import { render, staticRenderFns } from "./VideosStreamSettings.vue?vue&type=template&id=2f7135a6"
import script from "./VideosStreamSettings.vue?vue&type=script&lang=js"
export * from "./VideosStreamSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports